import { Suspense, lazy } from "react";
import { Navigate, Route, Routes, useNavigate, useParams, useSearchParams } from "react-router-dom";
import "./App.css";
import MainLayout from "./layouts/MainLayout.jsx";
import ResponsivePage from "./components/ResponsivePage.jsx";
import NotFound from "./pages/NotFound.jsx";
import AdminLogin from "./pages/admin/AdminLogin.jsx";
import { useAdminAuth } from "./legacy/context/AdminAuthContext.js";
import useCustomerAuth from "./legacy/hooks/useCustomerAuth.js";
import useHostAuth from "./legacy/hooks/useHostAuth.js";
import useModuleAuth from "./legacy/hooks/useModuleAuth.js";
import RoleRoute from "./legacy/components/RoleRoute.jsx";
import HostRoute from "./legacy/components/HostRoute.jsx";
import ProtectedRoute from "./legacy/components/ProtectedRoute.jsx";
import HostLayout from "./legacy/components/host/HostLayout.jsx";
import GuestDashboardLayout from "./legacy/components/guest/GuestDashboardLayout.jsx";
import CustomersLayout from "./legacy/components/customers/CustomersLayout.jsx";
import LegacyAdminLayout from "./legacy/admin/layout/AdminLayout.jsx";
import BookingsPage from "./legacy/pages/BookingsPage.jsx";
import BookingDetailPage from "./legacy/pages/BookingDetailPage.jsx";
import BookingsCalendarPage from "./legacy/pages/BookingsCalendarPage.jsx";
import ContentBannersPage from "./legacy/pages/ContentBannersPage.jsx";
import ContentPopularDestinationsPage from "./legacy/pages/ContentPopularDestinationsPage.jsx";
import ContentHeroPanelsPage from "./legacy/pages/ContentHeroPanelsPage.jsx";
import ContentHeroBannerPage from "./legacy/pages/ContentHeroBannerPage.jsx";
import ContentBlogsPage from "./legacy/pages/ContentBlogsPage.jsx";
import ContentFooterPage from "./legacy/pages/ContentFooterPage.jsx";
import ContentPagesPage from "./legacy/pages/ContentPagesPage.jsx";
import ChannelProvidersPage from "./legacy/pages/ChannelProvidersPage.jsx";
import ChannelProviderDetailPage from "./legacy/pages/ChannelProviderDetailPage.jsx";
import ChannelConnectionsPage from "./legacy/pages/ChannelConnectionsPage.jsx";
import ChannelConnectionDetailPage from "./legacy/pages/ChannelConnectionDetailPage.jsx";
import ChannelMappingsPage from "./legacy/pages/ChannelMappingsPage.jsx";
import ChannelSyncMonitorPage from "./legacy/pages/ChannelSyncMonitorPage.jsx";
import AdminHostsList from "./legacy/pages/AdminHostsList.jsx";
import AdminHostDetail from "./legacy/pages/AdminHostDetail.jsx";
import CustomersList from "./legacy/pages/customers/CustomersList.jsx";
import CustomerDetail from "./legacy/pages/customers/CustomerDetail.jsx";
import ReviewsPage from "./legacy/pages/customers/ReviewsPage.jsx";
import TicketsPage from "./legacy/pages/customers/TicketsPage.jsx";
import AdminPendingProperties from "./legacy/pages/admin/AdminPendingProperties.jsx";
import AdminPropertyTypes from "./legacy/pages/admin/AdminPropertyTypes.jsx";
import AdminAmenities from "./legacy/pages/admin/AdminAmenities.jsx";
import AdminLocations from "./legacy/pages/admin/AdminLocations.jsx";
import AdminPolicies from "./legacy/pages/admin/AdminPolicies.jsx";
import AdminCancellations from "./legacy/pages/admin/AdminCancellations.jsx";
import AdminCancellationDetail from "./legacy/pages/admin/AdminCancellationDetail.jsx";
import AdminPayouts from "./legacy/pages/admin/AdminPayouts.jsx";
import AdminPayoutDetail from "./legacy/pages/admin/AdminPayoutDetail.jsx";
import AdminRefunds from "./legacy/pages/admin/AdminRefunds.jsx";
import AdminHostKyc from "./legacy/pages/admin/AdminHostKyc.jsx";
import AdminHostBankAccounts from "./legacy/pages/admin/AdminHostBankAccounts.jsx";
import AdminHostPerformance from "./legacy/pages/admin/AdminHostPerformance.jsx";
import AdminReviewDetail from "./legacy/pages/admin/AdminReviewDetail.jsx";
import AdminMessages from "./legacy/pages/admin/AdminMessages.jsx";
import AdminAiConversations from "./legacy/pages/admin/AdminAiConversations.jsx";
import AdminCoupons from "./legacy/pages/admin/AdminCoupons.jsx";
import AdminReports from "./legacy/pages/admin/AdminReports.jsx";
import AdminVisitorAnalytics from "./legacy/pages/admin/AdminVisitorAnalytics.jsx";
import { AdminSeasonalPricing, AdminSpecialOffers, AdminTaxesFees } from "./legacy/pages/admin/AdminPricingRules.jsx";
import AdminPaymentSettings from "./legacy/pages/admin/AdminPaymentSettings.jsx";
import AdminPartialPayment from "./legacy/pages/admin/AdminPartialPayment.jsx";
import AdminTransactions from "./legacy/pages/admin/AdminTransactions.jsx";
import AdminFinanceSummary from "./legacy/pages/admin/AdminFinanceSummary.jsx";
import AdminLedgerEntries from "./legacy/pages/admin/AdminLedgerEntries.jsx";
import AdminLedgerAccounts from "./legacy/pages/admin/AdminLedgerAccounts.jsx";
import AdminPackages from "./legacy/pages/admin/AdminPackages.jsx";
import AdminPackageDestinations from "./legacy/pages/admin/AdminPackageDestinations.jsx";
import AdminPackageThemes from "./legacy/pages/admin/AdminPackageThemes.jsx";
import AdminPackageOffers from "./legacy/pages/admin/AdminPackageOffers.jsx";
import AdminPackageTestimonials from "./legacy/pages/admin/AdminPackageTestimonials.jsx";
import AdminPackageArticles from "./legacy/pages/admin/AdminPackageArticles.jsx";
import AdminPackageLanding from "./legacy/pages/admin/AdminPackageLanding.jsx";
import AdminPackageListing from "./legacy/pages/admin/AdminPackageListing.jsx";
import AdminPackageEnquiries from "./legacy/pages/admin/AdminPackageEnquiries.jsx";
import AdminPackageRequests from "./legacy/pages/admin/AdminPackageRequests.jsx";
import AdminPackageItineraries from "./legacy/pages/admin/AdminPackageItineraries.jsx";
import AdminCabsDashboard from "./legacy/pages/admin/cabs/AdminCabsDashboard.jsx";
import AdminCabsVehicles from "./legacy/pages/admin/cabs/AdminCabsVehicles.jsx";
import AdminCabsVehicleCategories from "./legacy/pages/admin/cabs/AdminCabsVehicleCategories.jsx";
import AdminCabsSeatConfigurations from "./legacy/pages/admin/cabs/AdminCabsSeatConfigurations.jsx";
import AdminCabsPricingRules from "./legacy/pages/admin/cabs/AdminCabsPricingRules.jsx";
import AdminCabsCabPackages from "./legacy/pages/admin/cabs/AdminCabsCabPackages.jsx";
import AdminCabsTransportPackages from "./legacy/pages/admin/cabs/AdminCabsTransportPackages.jsx";
import AdminCabsPackageVariants from "./legacy/pages/admin/cabs/AdminCabsPackageVariants.jsx";
import AdminCabsLocations from "./legacy/pages/admin/cabs/AdminCabsLocations.jsx";
import AdminCabsRoutes from "./legacy/pages/admin/cabs/AdminCabsRoutes.jsx";
import AdminCabsAmenities from "./legacy/pages/admin/cabs/AdminCabsAmenities.jsx";
import AdminCabsCoupons from "./legacy/pages/admin/cabs/AdminCabsCoupons.jsx";
import AdminCabsEnquiries from "./legacy/pages/admin/cabs/AdminCabsEnquiries.jsx";
import AdminCabsReviews from "./legacy/pages/admin/cabs/AdminCabsReviews.jsx";
import AdminCabsCms from "./legacy/pages/admin/cabs/AdminCabsCms.jsx";
import AdminCabsSettings from "./legacy/pages/admin/cabs/AdminCabsSettings.jsx";
import AdminCabsPopularRoutes from "./legacy/pages/admin/cabs/AdminCabsPopularRoutes.jsx";
import AdminCabsHeroBanners from "./legacy/pages/admin/cabs/AdminCabsHeroBanners.jsx";
import AdminCabsVehicleBanner from "./legacy/pages/admin/cabs/AdminCabsVehicleBanner.jsx";
import AdminCabsGuestTrips from "./legacy/pages/admin/cabs/AdminCabsGuestTrips.jsx";
import AdminCabsBlogs from "./legacy/pages/admin/cabs/AdminCabsBlogs.jsx";
import AdminCabsPromoVideos from "./legacy/pages/admin/cabs/AdminCabsPromoVideos.jsx";
import AdminCabsFooter from "./legacy/pages/admin/cabs/AdminCabsFooter.jsx";
import AdminRoles from "./legacy/pages/admin/AdminRoles.jsx";
import AdminSubAdmins from "./legacy/pages/admin/AdminSubAdmins.jsx";
import AdminSecurity from "./legacy/pages/admin/AdminSecurity.jsx";
import AdminAuditLogs from "./legacy/pages/admin/AdminAuditLogs.jsx";
import AdminChangePassword from "./legacy/pages/admin/AdminChangePassword.jsx";
import AdminSearchSettings from "./legacy/pages/admin/AdminSearchSettings.jsx";
import AdminInvoicesList from "./legacy/pages/admin/InvoicesList.jsx";
import AdminInvoiceDetail from "./legacy/pages/admin/InvoiceDetail.jsx";
import EmailDashboard from "./legacy/pages/admin/email/EmailDashboard.jsx";
import EmailMailLogs from "./legacy/pages/admin/email/EmailMailLogs.jsx";
import EmailCampaigns from "./legacy/pages/admin/email/EmailCampaigns.jsx";
import EmailCampaignComposer from "./legacy/pages/admin/email/EmailCampaignComposer.jsx";
import EmailTemplates from "./legacy/pages/admin/email/EmailTemplates.jsx";
import EmailAudience from "./legacy/pages/admin/email/EmailAudience.jsx";
import EmailQueue from "./legacy/pages/admin/email/EmailQueue.jsx";
import EmailSettings from "./legacy/pages/admin/email/EmailSettings.jsx";
import EmailReports from "./legacy/pages/admin/email/EmailReports.jsx";
import CustomerLogin from "./legacy/pages/CustomerLogin.jsx";
import CustomerAuthPage from "./legacy/pages/CustomerAuthPage.jsx";
import HostLogin from "./legacy/pages/HostLogin.jsx";
import HostDashboard from "./legacy/pages/HostDashboard.jsx";
import HostProperties from "./legacy/pages/HostProperties.jsx";
import HostPropertyForm from "./legacy/pages/HostPropertyForm.jsx";
import HostBookings from "./legacy/pages/HostBookings.jsx";
import HostProfile from "./legacy/pages/HostProfile.jsx";
import HostCalendar from "./legacy/pages/HostCalendar.jsx";
import HostCancellations from "./legacy/pages/HostCancellations.jsx";
import HostEarnings from "./legacy/pages/HostEarnings.jsx";
import HostPayouts from "./legacy/pages/HostPayouts.jsx";
import HostTransactions from "./legacy/pages/HostTransactions.jsx";
import HostReviews from "./legacy/pages/HostReviews.jsx";
import HostMessages from "./legacy/pages/HostMessages.jsx";
import HostPricingDeals from "./legacy/pages/HostPricingDeals.jsx";
import HostBankAccount from "./legacy/pages/HostBankAccount.jsx";
import HostSupport from "./legacy/pages/host/Support.jsx";
import HostReports from "./legacy/pages/HostReports.jsx";
import HostInvoicesList from "./legacy/pages/host/InvoicesList.jsx";
import HostInvoiceDetail from "./legacy/pages/host/InvoiceDetail.jsx";
import GuestDashboard from "./legacy/pages/guest/GuestDashboard.jsx";
import GuestBookings from "./legacy/pages/guest/GuestBookings.jsx";
import GuestUpcoming from "./legacy/pages/guest/GuestUpcoming.jsx";
import GuestPayments from "./legacy/pages/guest/GuestPayments.jsx";
import GuestRefunds from "./legacy/pages/guest/GuestRefunds.jsx";
import GuestMessages from "./legacy/pages/guest/GuestMessages.jsx";
import GuestWishlist from "./legacy/pages/guest/GuestWishlist.jsx";
import GuestSupport from "./legacy/pages/guest/GuestSupport.jsx";
import GuestProfile from "./legacy/pages/guest/GuestProfile.jsx";
import GuestInvoicesList from "./legacy/pages/guest/InvoicesList.jsx";
import GuestInvoiceDetail from "./legacy/pages/guest/InvoiceDetail.jsx";
import Login from "./legacy/pages/Login.jsx";
import HomeLocked from "./pages/HomeLocked.jsx";
import AdminPropertyPricingDealsPage from "./pages/admin/AdminPropertyPricingDealsPage.jsx";
import LegacyListingPage from "./legacy/pages/ListingPage.jsx";
import PackagesLanding from "./legacy/pages/PackagesLanding.jsx";
import PackagesListPage from "./legacy/pages/PackagesListPage.jsx";
import PackageDetail from "./legacy/pages/PackageDetail.jsx";
import PackageEnquiryPage from "./legacy/pages/PackageEnquiryPage.jsx";
import CabsLayout from "./legacy/modules/cabs/CabsLayout.jsx";
import CabsLanding from "./legacy/modules/cabs/CabsLanding.jsx";
import CabsList from "./legacy/modules/cabs/CabsList.jsx";
import CabsDetail from "./legacy/modules/cabs/CabsDetail.jsx";
import CabsPackagesLanding from "./legacy/modules/cabs/CabsPackagesLanding.jsx";
import CabsPackagesList from "./legacy/modules/cabs/CabsPackagesList.jsx";
import CabsPackageDetail from "./legacy/modules/cabs/CabsPackageDetail.jsx";
import CabsVehicleEnquiry from "./legacy/modules/cabs/CabsVehicleEnquiry.jsx";
import CabsPackageEnquiry from "./legacy/modules/cabs/CabsPackageEnquiry.jsx";
import CabsEnquirySuccess from "./legacy/modules/cabs/CabsEnquirySuccess.jsx";
import StaticPage from "./pages/StaticPage.jsx";
import ShortLinkRedirect from "./pages/ShortLinkRedirect.jsx";
import BlogList from "./legacy/pages/BlogList.jsx";
import BlogDetail from "./legacy/pages/BlogDetail.jsx";
import CustomTourRequestPage from "./pages/CustomTourRequestPage.jsx";
import BookingSuccess from "./legacy/pages/BookingSuccess.jsx";
import InvoicePage from "./legacy/pages/InvoicePage.jsx";
import MobileHome from "./mobile/pages/MobileHome.jsx";
import MobileStays from "./mobile/pages/MobileStays.jsx";
import MobileSearch from "./mobile/pages/MobileSearch.jsx";
import MobilePackages from "./mobile/pages/MobilePackages.jsx";
import MobileCabs from "./mobile/pages/MobileCabs.jsx";
import MobileLogin from "./mobile/pages/MobileLogin.jsx";
import MobileAccount from "./mobile/pages/MobileAccount.jsx";
import MobileDateGuestSelector from "./mobile/pages/MobileDateGuestSelector.jsx";
import MobilePropertyDetail from "./mobile/pages/MobilePropertyDetail.jsx";
import MobileBookingPolicyPage from "./mobile/pages/MobileBookingPolicyPage.jsx";
import { MobileBookingReview, MobileBookingSuccess, MobilePaymentMethod, MobileTravelerInfo } from "./mobile/pages/MobileBookingFlow.jsx";

const DashboardHome = lazy(() => import("./legacy/admin/pages/DashboardHome.jsx"));
const PropertiesPage = lazy(() => import("./legacy/pages/PropertiesPage.jsx"));
const PropertyFormPage = lazy(() => import("./legacy/pages/PropertyFormPage.jsx"));
const GuestDetailsPage = lazy(() => import("./legacy/pages/GuestDetailsPage.jsx"));
const BookingReview = lazy(() => import("./legacy/pages/BookingReview.jsx"));
const PaymentPage = lazy(() => import("./legacy/pages/PaymentPage.jsx"));
const PropertyDetailExperiencePage = lazy(() => import("./pages/property/PropertyDetailExperiencePage.jsx"));

function ExternalStayRedirect() {
  const { propertyId } = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  return (
    <Navigate
      to={`/stays/homevilas/${encodeURIComponent(propertyId || "")}${query ? `?${query}` : ""}`}
      replace
    />
  );
}

export default function App() {
  const navigate = useNavigate();
  const { accessToken } = useAdminAuth();
  const customerAuth = useCustomerAuth();
  const hostAuth = useHostAuth();
  const moduleAuth = useModuleAuth();

  const handleHostLogout = async () => {
    await hostAuth.logout();
    navigate("/host/login", { replace: true });
  };

  const renderHostPage = (node) => (
    <RoleRoute role="host" redirectTo="/host/login" token={hostAuth.accessToken} validate={false}>
      <HostRoute isAuthed={!!hostAuth.host} token={hostAuth.accessToken} loading={hostAuth.loading}>
        <HostLayout host={hostAuth.host} onLogout={handleHostLogout} accessToken={hostAuth.accessToken}>
          {node}
        </HostLayout>
      </HostRoute>
    </RoleRoute>
  );

  return (
    <Suspense fallback={<div style={{ padding: "24px", color: "#475569" }}>Loading...</div>}>
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<ResponsivePage desktop={HomeLocked} mobile={MobileHome} />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route
          path="/about"
          element={
            <StaticPage
              slug="about"
              title="About Us"
              description="Learn more about Homevilas and our curated stays."
            />
          }
        />
        <Route
          path="/contact"
          element={
            <StaticPage
              slug="contact"
              title="Contact Us"
              description="Reach out to the Homevilas team for bookings and support."
            />
          }
        />
        <Route
          path="/careers"
          element={
            <StaticPage
              slug="careers"
              title="Careers"
              description="Explore opportunities to work with Homevilas."
            />
          }
        />
        <Route
          path="/help"
          element={
            <StaticPage
              slug="help"
              title="Help Center"
              description="Find support for bookings, stays, and account questions."
            />
          }
        />
        <Route
          path="/partner-with-us"
          element={
            <StaticPage
              slug="partner-with-us"
              title="Partner With Us"
              description="Explore B2B and partnership opportunities with Homevilas."
            />
          }
        />
        <Route
          path="/b2b-registration"
          element={
            <StaticPage
              slug="b2b-registration"
              title="B2B Registration"
              description="Register your business interest with Homevilas."
            />
          }
        />
        <Route path="/b2b" element={<Navigate to="/b2b-registration" replace />} />
        <Route path="/become-a-host" element={<Navigate to="/host/signup" replace />} />
        <Route
          path="/privacy"
          element={
            <StaticPage
              slug="privacy"
              title="Privacy Policy"
              description="Review how Homevilas collects and protects your data."
            />
          }
        />
        <Route
          path="/terms"
          element={
            <StaticPage
              slug="terms"
              title="Terms & Conditions"
              description="Read the terms and conditions for using Homevilas services."
            />
          }
        />
        <Route path="/search" element={<ResponsivePage desktop={LegacyListingPage} mobile={MobileSearch} />} />
        <Route path="/listings" element={<ResponsivePage desktop={LegacyListingPage} mobile={MobileStays} />} />
        <Route path="/s/:code" element={<ShortLinkRedirect />} />
        <Route path="/stays" element={<ResponsivePage desktop={LegacyListingPage} mobile={MobileStays} />} />
        <Route path="/listings/:slug" element={<ResponsivePage desktop={PropertyDetailExperiencePage} mobile={MobilePropertyDetail} />} />
        <Route path="/stays/homevilas/:propertyId" element={<ResponsivePage desktop={PropertyDetailExperiencePage} mobile={MobilePropertyDetail} />} />
        <Route path="/stays/elivaas/:propertyId" element={<ExternalStayRedirect />} />
        <Route path="/stays/:slug" element={<ResponsivePage desktop={PropertyDetailExperiencePage} mobile={MobilePropertyDetail} />} />
        <Route path="/property/:slug" element={<ResponsivePage desktop={PropertyDetailExperiencePage} mobile={MobilePropertyDetail} />} />
        <Route path="/packages" element={<ResponsivePage desktop={PackagesLanding} mobile={MobilePackages} />} />
        <Route path="/packages/list" element={<PackagesListPage />} />
        <Route path="/packages/enquiry/:packageSlug" element={<PackageEnquiryPage />} />
        <Route path="/packages/:slug" element={<PackageDetail />} />
        <Route path="/custom-tour" element={<CustomTourRequestPage />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/booking/select-dates" element={<MobileDateGuestSelector />} />
        <Route path="/booking/guest" element={<ResponsivePage desktop={GuestDetailsPage} mobile={MobileTravelerInfo} />} />
        <Route path="/guest-details" element={<ResponsivePage desktop={GuestDetailsPage} mobile={MobileTravelerInfo} />} />
        <Route path="/booking/review" element={<ResponsivePage desktop={BookingReview} mobile={MobileBookingReview} />} />
        <Route path="/booking/policy/:policyType" element={<MobileBookingPolicyPage />} />
        <Route path="/booking/payment" element={<ResponsivePage desktop={PaymentPage} mobile={MobilePaymentMethod} />} />
        <Route path="/booking/success/:bookingId" element={<ResponsivePage desktop={BookingSuccess} mobile={MobileBookingSuccess} />} />
        <Route path="/invoice/:bookingId" element={<InvoicePage />} />
        <Route path="/payment" element={<ResponsivePage desktop={PaymentPage} mobile={MobilePaymentMethod} />} />
        <Route path="/payment/:bookingId" element={<ResponsivePage desktop={PaymentPage} mobile={MobilePaymentMethod} />} />
        <Route path="/checkout" element={<ResponsivePage desktop={PaymentPage} mobile={MobilePaymentMethod} />} />
        <Route path="/cabs" element={<ResponsivePage desktop={CabsLayout} mobile={MobileCabs} />}>
          <Route index element={<CabsLanding />} />
          <Route path="list" element={<CabsList />} />
          <Route path=":vehicleId" element={<CabsDetail />} />
          <Route path=":vehicleId/enquiry" element={<CabsVehicleEnquiry />} />
          <Route path="enquiry/success" element={<CabsEnquirySuccess />} />
          <Route path="packages" element={<CabsPackagesLanding />} />
          <Route path="packages/list" element={<CabsPackagesList />} />
          <Route path="packages/:slug" element={<CabsPackageDetail />} />
          <Route path="packages/:slug/enquiry" element={<CabsPackageEnquiry />} />
        </Route>
      </Route>

      <Route
        path="/account/login"
        element={
          <ResponsivePage
            desktop={CustomerLogin}
            mobile={MobileLogin}
            desktopProps={{ customerAuth }}
          />
        }
      />
      <Route path="/account" element={<ResponsivePage desktopElement={<Navigate to="/guest/dashboard" replace />} mobile={MobileAccount} />} />
      <Route path="/customer/login" element={<ResponsivePage desktop={CustomerLogin} mobile={MobileLogin} desktopProps={{ customerAuth }} />} />
      <Route
        path="/customer/signup"
        element={<ResponsivePage desktopElement={<CustomerAuthPage customerAuth={customerAuth} hostAuth={hostAuth} defaultTab="customer-signup" />} mobile={MobileLogin} mobileProps={{ initialSignup: true }} />}
      />
      <Route
        path="/customer/register"
        element={<Navigate to="/customer/signup" replace />}
      />
      <Route path="/host/login" element={<HostLogin hostAuth={hostAuth} />} />
      <Route
        path="/host/signup"
        element={<CustomerAuthPage customerAuth={customerAuth} hostAuth={hostAuth} defaultTab="host-signup" />}
      />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/guest/login" element={<Navigate to="/customer/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth" element={<CustomerAuthPage customerAuth={customerAuth} hostAuth={hostAuth} />} />

      <Route
        path="/guest"
        element={
          <RoleRoute role="guest" redirectTo="/customer/login" token={customerAuth.accessToken}>
            <GuestDashboardLayout />
          </RoleRoute>
        }
      >
        <Route path="dashboard" element={<GuestDashboard />} />
        <Route path="bookings" element={<GuestBookings />} />
        <Route path="upcoming" element={<GuestUpcoming />} />
        <Route path="payments" element={<GuestPayments />} />
        <Route path="refunds" element={<GuestRefunds />} />
        <Route path="messages" element={<GuestMessages />} />
        <Route path="wishlist" element={<GuestWishlist />} />
        <Route path="support" element={<GuestSupport />} />
        <Route path="profile" element={<GuestProfile />} />
        <Route path="invoices" element={<GuestInvoicesList />} />
        <Route path="invoices/:invoiceId" element={<GuestInvoiceDetail />} />
        <Route index element={<Navigate to="/guest/dashboard" replace />} />
      </Route>

      <Route
        element={
          <ProtectedRoute isAuthed={!!moduleAuth.token}>
            <CustomersLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/customers" element={<CustomersList />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/tickets" element={<TicketsPage />} />
      </Route>

      <Route
        path="/admin"
        element={
          <RoleRoute role="admin" redirectTo="/admin/login" token={accessToken}>
            <LegacyAdminLayout />
          </RoleRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="dashboard" element={<DashboardHome />} />
        <Route path="analytics" element={<AdminReports token={accessToken} />} />
        <Route path="visitor-analytics" element={<AdminVisitorAnalytics />} />
        <Route path="properties" element={<PropertiesPage token={accessToken} />} />
        <Route path="properties/new" element={<PropertyFormPage token={accessToken} />} />
        <Route path="properties/pending" element={<AdminPendingProperties token={accessToken} />} />
        <Route path="properties/types" element={<AdminPropertyTypes token={accessToken} />} />
        <Route path="properties/:id" element={<PropertyFormPage token={accessToken} />} />
        <Route path="properties/:id/edit" element={<PropertyFormPage token={accessToken} />} />
        <Route path="properties/:id/pricing-deals" element={<AdminPropertyPricingDealsPage />} />
        <Route path="amenities" element={<AdminAmenities token={accessToken} />} />
        <Route path="locations" element={<AdminLocations token={accessToken} />} />
        <Route path="policies" element={<AdminPolicies token={accessToken} />} />
        <Route path="pricing/seasonal" element={<AdminSeasonalPricing />} />
        <Route path="pricing/coupons" element={<AdminCoupons />} />
        <Route path="pricing/offers" element={<AdminSpecialOffers />} />
        <Route path="pricing/taxes" element={<AdminTaxesFees />} />
        <Route path="pricing/partial-payment" element={<AdminPartialPayment token={accessToken} />} />
        <Route path="coupons" element={<AdminCoupons />} />
        <Route path="bookings" element={<BookingsPage token={accessToken} />} />
        <Route path="bookings/upcoming-checkins" element={<BookingsPage token={accessToken} view="upcoming-checkins" />} />
        <Route path="bookings/checkouts-today" element={<BookingsPage token={accessToken} view="checkouts-today" />} />
        <Route
          path="bookings/cancellations-refunds"
          element={<BookingsPage token={accessToken} view="cancellations-refunds" />}
        />
        <Route path="bookings/calendar" element={<BookingsCalendarPage token={accessToken} />} />
        <Route path="bookings/:id" element={<BookingDetailPage token={accessToken} />} />
        <Route path="ai" element={<AdminAiConversations token={accessToken} />} />
        <Route path="cancellations" element={<AdminCancellations token={accessToken} />} />
        <Route path="cancellations/:id" element={<AdminCancellationDetail token={accessToken} />} />
        <Route path="reports" element={<AdminReports token={accessToken} />} />
        <Route path="reports/:tab" element={<AdminReports token={accessToken} />} />
        <Route path="payments/transactions" element={<AdminTransactions token={accessToken} />} />
        <Route path="payments/settlements" element={<AdminPayouts token={accessToken} />} />
        <Route path="payments/refunds" element={<AdminRefunds token={accessToken} />} />
        <Route path="payments/settings" element={<AdminPaymentSettings token={accessToken} />} />
        <Route path="finance/summary" element={<AdminFinanceSummary token={accessToken} />} />
        <Route path="finance/entries" element={<AdminLedgerEntries token={accessToken} />} />
        <Route path="finance/accounts" element={<AdminLedgerAccounts token={accessToken} />} />
        <Route path="finance" element={<Navigate to="/admin/finance/summary" replace />} />
        <Route path="invoices" element={<AdminInvoicesList token={accessToken} />} />
        <Route path="invoices/:invoiceId" element={<AdminInvoiceDetail token={accessToken} />} />
        <Route path="email" element={<EmailDashboard />} />
        <Route path="email/logs" element={<EmailMailLogs />} />
        <Route path="email/campaigns" element={<EmailCampaigns />} />
        <Route path="email/campaigns/new" element={<EmailCampaignComposer />} />
        <Route path="email/campaigns/:id" element={<EmailCampaignComposer />} />
        <Route path="email/templates" element={<EmailTemplates />} />
        <Route path="email/audience" element={<EmailAudience />} />
        <Route path="email/queue" element={<EmailQueue />} />
        <Route path="email/settings" element={<EmailSettings />} />
        <Route path="email/reports" element={<EmailReports />} />
        <Route path="payouts" element={<AdminPayouts token={accessToken} />} />
        <Route path="payouts/:id" element={<AdminPayoutDetail token={accessToken} />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="reviews/:id" element={<AdminReviewDetail token={accessToken} />} />
        <Route path="content/banners" element={<ContentBannersPage token={accessToken} />} />
        <Route
          path="content/popular-destinations"
          element={<ContentPopularDestinationsPage token={accessToken} />}
        />
        <Route path="content/hero-panels" element={<ContentHeroPanelsPage token={accessToken} />} />
        <Route path="content/hero-banner" element={<ContentHeroBannerPage token={accessToken} />} />
        <Route path="content/blogs" element={<ContentBlogsPage token={accessToken} />} />
        <Route path="content/footer" element={<ContentFooterPage token={accessToken} />} />
        <Route path="content/pages" element={<ContentPagesPage token={accessToken} />} />
        <Route path="packages" element={<AdminPackages />} />
        <Route path="packages/destinations" element={<AdminPackageDestinations />} />
        <Route path="packages/themes" element={<AdminPackageThemes />} />
        <Route path="packages/landing" element={<AdminPackageLanding />} />
        <Route path="packages/listing" element={<AdminPackageListing />} />
        <Route path="packages/enquiries" element={<AdminPackageEnquiries />} />
        <Route path="packages/offers" element={<AdminPackageOffers />} />
        <Route path="packages/testimonials" element={<AdminPackageTestimonials />} />
        <Route path="packages/articles" element={<AdminPackageArticles />} />
        <Route path="packages/itineraries" element={<AdminPackageItineraries />} />
        <Route path="packages/bookings" element={<Navigate to="/admin/packages/enquiries" replace />} />
        <Route path="tours/requests" element={<AdminPackageRequests />} />
        <Route path="cabs" element={<AdminCabsDashboard />} />
        <Route path="cabs/dashboard" element={<Navigate to="/admin/cabs" replace />} />
        <Route path="cabs/vehicles" element={<AdminCabsVehicles />} />
        <Route path="cabs/vehicle-categories" element={<AdminCabsVehicleCategories />} />
        <Route path="cabs/seat-configurations" element={<AdminCabsSeatConfigurations />} />
        <Route path="cabs/pricing-rules" element={<AdminCabsPricingRules />} />
        <Route path="cabs/cab-packages" element={<AdminCabsCabPackages />} />
        <Route path="cabs/transport-packages" element={<AdminCabsTransportPackages />} />
        <Route path="cabs/package-variants" element={<AdminCabsPackageVariants />} />
        <Route path="cabs/locations" element={<AdminCabsLocations />} />
        <Route path="cabs/routes" element={<AdminCabsRoutes />} />
        <Route path="cabs/amenities" element={<AdminCabsAmenities />} />
        <Route path="cabs/coupons" element={<AdminCabsCoupons />} />
        <Route path="cabs/popular-routes" element={<AdminCabsPopularRoutes />} />
        <Route path="cabs/hero-banners" element={<AdminCabsHeroBanners />} />
        <Route path="cabs/vehicle-banner" element={<AdminCabsVehicleBanner />} />
        <Route path="cabs/guest-trips" element={<AdminCabsGuestTrips />} />
        <Route path="cabs/blogs" element={<AdminCabsBlogs />} />
        <Route path="cabs/promo-videos" element={<AdminCabsPromoVideos />} />
        <Route path="cabs/footer" element={<AdminCabsFooter />} />
        <Route path="cabs/enquiries" element={<AdminCabsEnquiries />} />
        <Route path="cabs/reviews" element={<AdminCabsReviews />} />
        <Route path="cabs/cms" element={<AdminCabsCms />} />
        <Route path="cabs/landing" element={<AdminCabsCms />} />
        <Route path="cabs/settings" element={<AdminCabsSettings />} />
        <Route path="vehicles" element={<AdminCabsVehicleBanner />} />
        <Route path="guest-trips" element={<AdminCabsGuestTrips />} />
        <Route path="blogs" element={<AdminCabsBlogs />} />
        <Route path="promo-videos" element={<AdminCabsPromoVideos />} />
        <Route path="footer" element={<AdminCabsFooter />} />
        <Route path="channel/providers" element={<ChannelProvidersPage token={accessToken} />} />
        <Route path="channel/providers/:id" element={<ChannelProviderDetailPage token={accessToken} />} />
        <Route path="channel/connections" element={<ChannelConnectionsPage token={accessToken} />} />
        <Route path="channel/connections/:id" element={<ChannelConnectionDetailPage token={accessToken} />} />
        <Route path="channel/mappings" element={<ChannelMappingsPage token={accessToken} />} />
        <Route path="channel/monitor" element={<ChannelSyncMonitorPage token={accessToken} />} />
        <Route path="hosts" element={<AdminHostsList token={accessToken} />} />
        <Route path="hosts/:id" element={<AdminHostDetail token={accessToken} />} />
        <Route path="hosts/kyc" element={<AdminHostKyc token={accessToken} />} />
        <Route path="hosts/bank-accounts" element={<AdminHostBankAccounts token={accessToken} />} />
        <Route path="hosts/performance" element={<AdminHostPerformance token={accessToken} />} />
        <Route path="messages" element={<AdminMessages token={accessToken} />} />
        <Route path="support" element={<TicketsPage />} />
        <Route path="customers" element={<CustomersList />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="settings/roles" element={<AdminRoles />} />
        <Route path="settings/sub-admins" element={<AdminSubAdmins />} />
        <Route path="settings/permissions" element={<AdminRoles />} />
        <Route path="settings/security" element={<AdminSecurity />} />
        <Route path="settings/audit-logs" element={<AdminAuditLogs />} />
        <Route path="settings/search-configuration" element={<AdminSearchSettings token={accessToken} />} />
        <Route path="change-password" element={<AdminChangePassword />} />
        <Route path="roles" element={<AdminRoles />} />
        <Route path="sub-admins" element={<AdminSubAdmins />} />
        <Route path="permissions" element={<AdminRoles />} />
        <Route path="security" element={<AdminSecurity />} />
        <Route path="audit-logs" element={<AdminAuditLogs />} />
        <Route
          path="*"
          element={
            <div className="rounded-lg border border-slate-200 bg-white p-6 text-slate-600">
              This admin section is coming soon.
            </div>
          }
        />
      </Route>

      <Route path="/host/dashboard" element={renderHostPage(<HostDashboard accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/properties" element={renderHostPage(<HostProperties accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/properties/new" element={renderHostPage(<HostPropertyForm accessToken={hostAuth.accessToken} />)} />
      <Route
        path="/host/properties/:id/edit"
        element={renderHostPage(<HostPropertyForm accessToken={hostAuth.accessToken} />)}
      />
      <Route path="/host/calendar" element={renderHostPage(<HostCalendar accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/bookings" element={renderHostPage(<HostBookings accessToken={hostAuth.accessToken} />)} />
      <Route
        path="/host/cancellations"
        element={renderHostPage(<HostCancellations accessToken={hostAuth.accessToken} />)}
      />
      <Route path="/host/earnings" element={renderHostPage(<HostEarnings accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/bank-account" element={renderHostPage(<HostBankAccount accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/payouts" element={renderHostPage(<HostPayouts accessToken={hostAuth.accessToken} />)} />
      <Route
        path="/host/transactions"
        element={renderHostPage(<HostTransactions accessToken={hostAuth.accessToken} />)}
      />
      <Route path="/host/invoices" element={renderHostPage(<HostInvoicesList accessToken={hostAuth.accessToken} />)} />
      <Route
        path="/host/invoices/:invoiceId"
        element={renderHostPage(<HostInvoiceDetail accessToken={hostAuth.accessToken} />)}
      />
      <Route path="/host/reviews" element={renderHostPage(<HostReviews accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/messages" element={renderHostPage(<HostMessages accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/pricing" element={renderHostPage(<HostPricingDeals accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/promotions" element={renderHostPage(<HostPricingDeals accessToken={hostAuth.accessToken} />)} />
      <Route
        path="/host/profile"
        element={renderHostPage(
          <HostProfile accessToken={hostAuth.accessToken} onProfileUpdate={hostAuth.setHost} />
        )}
      />
      <Route path="/host/support" element={renderHostPage(<HostSupport accessToken={hostAuth.accessToken} />)} />
      <Route path="/host/reports" element={renderHostPage(<HostReports accessToken={hostAuth.accessToken} />)} />

      <Route path="/customer/dashboard" element={<Navigate to="/guest/dashboard" replace />} />
      <Route path="/customer/bookings" element={<Navigate to="/guest/bookings" replace />} />
      <Route path="/customer/bookings/:id" element={<Navigate to="/guest/bookings" replace />} />
      <Route path="/customer/profile" element={<Navigate to="/guest/profile" replace />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
    </Suspense>
  );
}
